import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Select } from 'antd';
import PropTypes from 'prop-types';

import * as fetchCategory from '~/store/fetchActions/fetchCategory';

const { Option } = Select;

export default function ControlledSelectCategory({
  category,
  onChangeCategory,
}) {
  const { isLoadingCategory } = useSelector(state => state.loading);
  const { categories } = useSelector(state => state.categories);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCategory.get());
  }, [dispatch]);

  return (
    <Select
      placeholder="Selecione uma Categoria"
      data-testid="category-select"
      style={{ minWidth: 200, height: 'fit-content' }}
      loading={isLoadingCategory}
      onChange={onChangeCategory}
      value={category || undefined}
      allowClear
    >
      {categories?.map(({ id, title }) => (
        <Option key={id} value={title}>
          {title}
        </Option>
      ))}
    </Select>
  );
}

ControlledSelectCategory.propTypes = {
  onChangeCategory: PropTypes.func,
  category: PropTypes.string,
};

ControlledSelectCategory.defaultProps = {
  onChangeCategory: () => {},
  category: undefined,
};
